import { Layout, ActivityTimeline } from 'components/widgets';
import { Stats } from 'components/containers';
import { usePathIndicator } from 'hooks';
import { LINKS } from 'utils/constants';

export default function StatsPage() {
  usePathIndicator(LINKS.stats);

  return (
    <Layout sidebar={<ActivityTimeline />}>
      <Stats />
    </Layout>
  );
}
